export enum DeviceAttributeEnum {
    NAME = 'name',
    MANUFACTURER = 'manufacturer',
    DEVICE_RCPN = 'deviceRcpn',
    SERIAL_NUMBER = 'serialNumber',
    STATUS_BADGE = 'statusBadge',
    PVL_RATED_CURRENT_A = 'pvlRatedCurrentA',
    PVL_RATED_POWER_WDC = 'pvlRatedPowerWDC'
}
